// Folds a just-inserted row id into the reference's selection `value`.
// Multi-select appends (deduped); single-select replaces. Returns `value`
// unchanged when there is no inserted id.
export const buildReferenceValueWithInsertedId = (
  value: string,
  insertedId: string | undefined,
  multiSelect: boolean | undefined,
  delimiter: string = ','
): string => {
  if (!insertedId) return value;
  if (!multiSelect) return insertedId;

  const ids = value ? value.split(delimiter).filter(Boolean) : [];
  if (ids.includes(insertedId)) return value;
  return [...ids, insertedId].join(delimiter);
};
